






















































































import Vue from 'vue';
import store from '@/store';
import Status from '@/components/Status.vue';
import { BaseOrganization, WebRequestStatus } from '@/models';
import * as Utils from '@/utils';
import { UserInfo } from '@/store/auth';

enum SortCriteria {
  name,
  created,
  count
}
enum SortDir {
  asc,
  desc
}

function getInitialDirection(criteria: SortCriteria) {
  switch (criteria) {
    case SortCriteria.name:
      return SortDir.asc;
    case SortCriteria.created:
      return SortDir.desc;
    case SortCriteria.count:
      return SortDir.desc;
  }
}

export default Vue.extend({
  components: {
    Status
  },
  data: () => {
    return {
      filter: '',
      activeCriteria: SortCriteria.name,
      activeDirection: SortDir.asc
    };
  },

  computed: {
    orgs(): BaseOrganization[] {
      return (store.state.orgs.data || []).map(o => {
        return {
          ...o,
          createdAtPretty: o.createdAt.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })
        };
      });
    },

    hasOrgCount(): boolean {
      return this.orgs.some(o => o.exhibitionCount);
    },

    status(): WebRequestStatus {
      return store.state.orgs.status;
    },
    sorted(): BaseOrganization[] {
      const orgs = this.filtered.slice();

      switch (this.activeCriteria) {
        case SortCriteria.name:
          return orgs.sort((a, b) =>
            Utils.sortNamed(
              a,
              b,
              this.activeDirection == SortDir.desc ? true : false
            )
          );
        case SortCriteria.created:
          return orgs.sort((a, b) => {
            const aIsBeforeB = a.createdAt < b.createdAt;

            switch (this.activeDirection) {
              case SortDir.asc:
                return aIsBeforeB ? -1 : 1;
              case SortDir.desc:
                return aIsBeforeB ? 1 : -1;
            }
          });
        case SortCriteria.count:
          return orgs.sort((a, b) => {
            const aCount = a.exhibitionCount ?? 0;
            const bCount = b.exhibitionCount ?? 0;

            switch (this.activeDirection) {
              case SortDir.asc:
                return aCount - bCount;
              case SortDir.desc:
                return bCount - aCount;
            }
          });
        default:
          return orgs;
      }
    },
    filtered(): BaseOrganization[] {
      const filtered = Utils.findTerm(this.filter, this.orgs, org => [
        org.name
      ]);

      // filtered.sort(Utils.sortNamed);

      return filtered;
    },
    showInput(): boolean {
      return this.orgs && this.orgs.length > 30;
    },

    showSignUp(): boolean {
      return this.status === WebRequestStatus.SUCCESS && this.orgs.length === 0;
    },

    user(): UserInfo | null {
      return store.state.auth.user;
    },

    criteriaIsName(): boolean {
      return this.activeCriteria == SortCriteria.name;
    },

    criteriaIsCreated(): boolean {
      return this.activeCriteria == SortCriteria.created;
    },

    criteriaIsCount(): boolean {
      return this.activeCriteria == SortCriteria.count;
    },

    directionIsAscending(): boolean {
      return this.activeDirection == SortDir.asc;
    },

    directionIsDescending(): boolean {
      return this.activeDirection == SortDir.desc;
    }
  },

  methods: {
    navigateToOrg({ organizationId }: BaseOrganization) {
      this.$router.push({
        name: 'Organization',
        params: { organizationId: `${organizationId}` }
      });
    },

    toggleSort(source: SortCriteria) {
      if (source == this.activeCriteria) {
        this.activeDirection =
          this.activeDirection == SortDir.asc ? SortDir.desc : SortDir.asc;
      } else {
        this.activeCriteria = source;
        this.activeDirection = getInitialDirection(source);
      }
    },

    toggleName() {
      this.toggleSort(SortCriteria.name);
    },

    toggleCreated() {
      this.toggleSort(SortCriteria.created);
    },

    togglePosts() {
      this.toggleSort(SortCriteria.count);
    }
  },

  watch: {
    orgs(current) {
      if (current.length === 1) {
        this.navigateToOrg(current[0]);
      }
    }
  }
});
